import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-updatenma',
  imports: [],
  templateUrl: './updatenma.component.html',
  styleUrl: './updatenma.component.css'
})
export class UpdatenmaComponent {
  constructor(private router: Router) {
    this.downloadNotes();
  }

  downloadNotes() {
    this.router.navigate(['/DOA']);
    const link = document.createElement('a');
    link.href = 'assets/DOA_Update_Guidelines.doc';
    link.download = 'DOA_Update_Guidelines.doc';
    link.click();
}
}
